<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="450px"
  >
    <template v-slot:activator="{ on:dialog }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn 
            icon 
            v-on="{ ...dialog, ...tooltip }"
          >
            <v-icon color="primary">
              mdi-pencil
            </v-icon>
          </v-btn>
        </template>
        <span>Rename</span>
      </v-tooltip>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="Folder"
      text="Edit Folder"
      class="mb-0"
    >
      <form v-if="dialog">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="localDocument.name"
                v-validate="'required'"
                :rules="folderRule"
                :error-messages="errors.collect('name')"
                data-vv-name="name"                
                label="Name"
              />
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    inject: ['$validator'],
    props: {
      document: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        dialog: null,
        progressing: false,
        localDocument: null,
        folderRule: [
          v =>
            /^[a-z .A-Z0-9-_()]+$/.test(v) ||
            'Special characters are not allowed',
        ],
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return
        this.localDocument = { ...this.document }
      },
    },
    methods: { 
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            this.$api.documents().update(this.localDocument.id, this.prepareFormData())
              .then(response => {
                this.$emit('updated', response.data)
                this.$snack({ message: 'Rename successfully' })

                this.progressing = false
                this.dialog = false
              })
              .catch(() => {
                this.progressing = false
              })
          })
      },
  
      prepareFormData () {
        return { 
          name: this.localDocument.name, 
        }
      },
    },
  }
</script>
